import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {
  @Input() arregloImagenes: any;
  @Input() linksCarrusel: any;
  sliderConfig = {
    autoplay: true,
    autoplaySpeed: 3000
  };

  constructor() {}

  ngOnInit() {
    this.arregloImagenes = JSON.parse(this.arregloImagenes);
    this.linksCarrusel = JSON.parse(this.linksCarrusel);
  }

  redireccion(link: string) {
    window.location.replace(link);
  }

}
